<script>
export default {
    name: "mine",
    data() {
        return {
            menu: [
                {
                    icon: require('@/assets/images/mine_icon_menu_01.png'),
                    iconChecked: require('@/assets/images/mine_icon_menu_01_checked.png'),
                    name: 'Dashboard',
                    path: '/mine/dashboard',
                },
                {
                    icon: require('@/assets/images/mine_icon_menu_02.png'),
                    iconChecked: require('@/assets/images/mine_icon_menu_02_checked.png'),
                    name: 'Support Desk',
                    path: '/mine/supportDesk',
                },
                {
                    icon: require('@/assets/images/mine_icon_menu_03.png'),
                    iconChecked: require('@/assets/images/mine_icon_menu_03_checked.png'),
                    name: 'Result',
                    path: '/mine/result',
                },
                {
                    icon: require('@/assets/images/mine_icon_menu_04.png'),
                    iconChecked: require('@/assets/images/mine_icon_menu_04_checked.png'),
                    name: 'Enrolled Courses',
                    path: '/mine/enrolledCourses',
                },
                {
                    icon: require('@/assets/images/mine_icon_menu_05.png'),
                    iconChecked: require('@/assets/images/mine_icon_menu_05_checked.png'),
                    name: 'Files',
                    path: '/mine/files',
                },
                {
                    icon: require('@/assets/images/mine_icon_menu_06.png'),
                    iconChecked: require('@/assets/images/mine_icon_menu_06_checked.png'),
                    name: 'Settings',
                    path: '/mine/settings',
                },
            ],
            logoutData: {
                icon: require('@/assets/images/mine_icon_menu_07.png'),
                iconChecked: require('@/assets/images/mine_icon_menu_07_checked.png'),
                name: 'Log Out',
                // path: '/mine/logout',
            }
        };
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {
        logout() {
            if (confirm('Have you confirmed to log out?')) {
                localStorage.removeItem('token');
                this.$store.state.isLogin = false;
                this.$store.state.userinfo = null;
                this.$router.replace('/login');
            }
        }
    },
};
</script>

<template>
    <div class="mine flex">
        <div class="menu_switch flex align_center">
            <div class="icon flex_center flex_column"><span></span><span></span><span></span></div>
            <p>Dashboard Navigation</p>
        </div>
        <div class="menu">
            <router-link class="item flex align_center" v-for="(item, index) in menu" :key="index" :to="item.path">
                <div class="layout_bg icon" :style="`background-image: url(${item.icon});`"></div>
                <div class="layout_bg icon checked" :style="`background-image: url(${item.iconChecked});`"></div>
                <span>{{ item.name }}</span>
            </router-link>
            <div class="item flex align_center" @click="logout">
                <div class="layout_bg icon" :style="`background-image: url(${logoutData.icon});`"></div>
                <div class="layout_bg icon checked" :style="`background-image: url(${logoutData.iconChecked});`"></div>
                <span>{{ logoutData.name }}</span>
            </div>
        </div>
        <div class="wrapper">
            <router-view></router-view>
        </div>
    </div>
</template>

<style scoped lang="scss">
.mine{
    flex: 1;
    background: #f5f5f5;
    @media only screen and (max-width: 750px) {
        flex-direction: column;
    }
    .wrapper{
        flex: 1;
        padding: .6rem .4rem;
        @media only screen and (max-width: 750px) {
            padding: .8rem .3rem;
        }
    }
}
.menu_switch{
    display: none;
    margin: 1rem .3rem .1rem;
    background: #e1e4ea;
    border-radius: .05rem;
    height: .5rem;
    color: var(--color-blue);
    font-size: .24rem;
    .icon{
        gap: .07rem;
        margin: 0 .2rem;
        span{
            width: .28rem;
            height: .03rem;
            background: var(--color-blue);
            border-radius: .03rem;
        }
    }
    @media only screen and (max-width: 750px) {
        display: flex;
    }
}
.menu{
    width: 3.15rem;
    background: #fff;
    padding: .6rem 0;
    flex-shrink: 0;
    @media only screen and (max-width: 750px) {
        width: auto;
        margin: 0 .3rem;
        padding: 0;
    }
    .item{
        padding-left: .6rem;
        font-size: .16rem;
        color: #999;
        height: .5rem;
        cursor: pointer;
        @media only screen and (max-width: 750px) {
            font-size: .24rem;
        }
        &.active{
            background: #00ccff;
            color: #fff;
            .icon{
                display: none;
                &.checked{
                    display: block;
                }
            }
        }
        .icon{
            width: .26rem;
            height: .26rem;
            margin-right: .15rem;
            &.checked{
                display: none;
            }
        }
    }
}
</style>